import EmailModalHOC from './EmailModalHOC';

export default EmailModalHOC;
